import { render, staticRenderFns } from "./InformUsers.vue?vue&type=template&id=a48285ea&"
import script from "./InformUsers.vue?vue&type=script&lang=js&"
export * from "./InformUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports